import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class AnniversaryBonus extends DomainObject {
  id;
  anniversary;
  rateAdjustment;
  effectiveRate;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      anniversary: observable,
      rateAdjustment: observable,
      effectiveRate: observable
    });

    this.merge(other);
  }
}

export default AnniversaryBonus;

